import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { ToastService } from 'ng-uikit-pro-standard';
import { FamiliaService } from 'src/app/services/familia.service';
import { IPTService } from 'src/app/services/ipt.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { RubroService } from 'src/app/services/rubro.service';
import { SignalRMessageService } from "src/app/services/SignalRMessage.service";
import { VendedorService } from 'src/app/services/vendedor.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import { FileDownloadService } from 'src/app/shared/services/file-download.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalShowClientesComponent } from 'src/app/views/acciones-comerciales/reglas-comerciales/modal-show-clientes/modal-show-clientes.component';
import { ModalSeleccionarClienteComponent } from 'src/app/views/shared/modal-seleccionar-cliente/modal-seleccionar-cliente.component';
import { IProductMultipleSelection, ModalSeleccionarProductoComponent } from 'src/app/views/shared/modal-seleccionar-producto/modal-seleccionar-producto.component';
import { ENVIRONMENT_FUNCTIONS } from 'src/environments/environment';

type MODE = 'ADD' | 'EDIT' | 'VIEW';

@Component({
  selector: 'app-vendedores-clientes',
  templateUrl: './vendedores-clientes.component.html',
  styleUrls: ['./vendedores-clientes.component.scss'],
  providers: [SecurityService],
})
export class VendedoresClientesComponent implements OnInit {
  // Constants
  readonly RB_TIPO_VISTA_CLIENTE: String = '_RB_TIPO_VISTA_CLIENTE_';
  readonly RB_TIPO_VISTA_CLIENTE_PRODUCTO: String = '_RB_TIPO_VISTA_CLIENTE_PRODUCTO_';
  readonly RB_TIPO_VISTA_PRODUCTO: String = '_RB_TIPO_VISTA_PRODUCTO_';
  readonly RB_VC = 'RB_VC';

  // Modales
  @ViewChild(ModalSeleccionarClienteComponent, { static: true }) modalSeleccionarCliente: ModalSeleccionarClienteComponent;
  @ViewChild(ModalShowClientesComponent, { static: true }) modalShowClientes: ModalShowClientesComponent;
  @ViewChild(ModalSeleccionarProductoComponent, { static: true }) modalSeleccionarProducto: ModalSeleccionarProductoComponent;
  @ViewChild('alert', { static: true }) alert: ElementRef;

  // Form
  formHeader: FormGroup;

  // Data & tmp
  private rutEmpresa: number;
  private rutUsuario: number;
  private sucursalCodigo: number;
  private cliente_currentPayload: any = null;
  cliente_loading: boolean = false;
  cliente_listaMovimientos: Array<any> = null;
  cliente_listaMovimientosAll: Array<any> = null;
  cliente_paginationContext: PaginationContext = new PaginationContext();
  cliente_totales: any = null;

  private cliente_producto_currentPayload: any = null;
  cliente_producto_loading: boolean = false;
  cliente_producto_listaMovimientos: Array<any> = null;
  cliente_producto_listaMovimientosAll: Array<any> = null;
  cliente_producto_paginationContext: PaginationContext = new PaginationContext();
  cliente_producto_totales: any = null;

  private producto_currentPayload: any = null;
  producto_loading: boolean = false;
  producto_listaMovimientos: Array<any> = null;
  producto_listaMovimientosAll: Array<any> = null;
  producto_paginationContext: PaginationContext = new PaginationContext();
  producto_totales: any = null;
  producto_groupArr: any;

  optionsVendedor: Array<any> = [];
  optionsIPT: Array<any> = [];
  optionsRubro: Array<any> = [];
  optionsFamilia: Array<any> = [];

  clientesSeleccionados: Array<any> = null;
  clientesSeleccionadosFormatted: any[] = null;
  productosMultiplesSeleccionados: any[] = null;
  mode: MODE;

  // Utils
  private log: any;

  constructor(
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private clog: ConsoleService,
    private messageRendererService: MessageRendererService,
    private toastService: ToastService,
    private fileDownloadService: FileDownloadService,
    private datesService: DatesService,
    private vendedorService: VendedorService,
    private rubroService: RubroService,
    private familiaService: FamiliaService,
    private rutService: RutService,
    private _IPTService: IPTService,
    private signalRMessageService: SignalRMessageService,
  ) {
    this.log = this.clog.log('REP. VTAS. VENDEDORES - CLIENTE');
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.rutUsuario = Number(this.accesolocalstorage.getRutUsuario());
    this.cliente_paginationContext.RecordsByPage = 10;
    this.cliente_producto_paginationContext.RecordsByPage = 10;
    this.producto_paginationContext.RecordsByPage = 2;

    this.loadVendedores();
    this.loadIPT();
    this.loadRubros();

    this.createForm();
    this.formChangesSubscriptions();
  }

  private loadRubros() {
    this.rubroService.obtenerRubrosReporteVenta(this.rutEmpresa, ({ respuesta }) => {
      const { registros } = respuesta; //.registros.filter(p => p.estado);
      this.optionsRubro = registros.map((rubro) => ({ value: rubro.codigo, label: rubro.descripcion, ...rubro }));
    });
  }

  loadVendedores() {
    this.vendedorService.obtenerActivos(this.rutEmpresa, this.sucursalCodigo, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      const { registros } = respuesta;
      this.optionsVendedor = registros.map((vendedor) => ({ value: vendedor.codigo, label: vendedor.nombre, ...vendedor }));
    });
  }

  loadIPT() {
    this._IPTService.listaIPT(({ respuesta }) => {
      const { registros } = respuesta;
      this.optionsIPT = registros.map((ipt) => ({ value: ipt.codigo, label: ipt.descripcion, ...ipt }));
    });
  }

  dateRangeValidator(): any {
    return (group: AbstractControl): { [key: string]: any } | null => {
      const fechaDesdeControl = group.get('fechaDesde').value;
      const fechaHastaControl = group.get('fechaHasta').value;

      // Obtener los valores de los campos 'fechaDesde' y 'fechaHasta' del FormGroup
      if (fechaDesdeControl && fechaHastaControl) {
        const fechaDesde = new Date(group.get('fechaDesde').value);
        const fechaHasta = new Date(group.get('fechaHasta').value);
        // Calcular la diferencia en meses entre las fechas
        const diffMonths = (fechaHasta.getFullYear() - fechaDesde.getFullYear()) * 12 + (fechaHasta.getMonth() - fechaDesde.getMonth());

        // Verificar si la diferencia es mayor a 12 meses
        if (diffMonths > 12) {
          //fechaDesdeControl.setErrors({ 'fechaDesdeMayor': true })
          return { 'fechaIngreso': true };
        }
      }
      return { 'fechaIngreso': false };
    }
  }

  private createForm() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth();
    this.formHeader = this.fb.group({
      tipoVista: [this.RB_TIPO_VISTA_CLIENTE, [Validators.required]],
      fechaDesde: [initDate, [Validators.required]],
      fechaHasta: [currentDate, [Validators.required]],
      listaVendedor: [[]],
      listaIptVentas: [[]],
      cliente_con_venta: [true],
      cliente_sin_venta: [false],
      listaClientes: [[]],
      listaProductos: [[]],
      rubros: [[]],
      familias: [[]],
      producto_sin_sku: [true],
      incl_cliente_inactivos: [false],
    }, { validator: this.dateRangeValidator() });
  }

  formChangesSubscriptions() {
    this.formHeader.get('tipoVista').valueChanges.subscribe((tipoVista: string) => {
      if (tipoVista === this.RB_TIPO_VISTA_CLIENTE) {
        //this.formHeader.get("listaVendedor").setValue([])
      }
    });
    this.formHeader.get('rubros').valueChanges.subscribe((rubro: string) => {
      this.onRubroSelect(rubro);
    });

    // this.formHeader.get("sku").valueChanges
    //   .pipe(filter(Boolean), debounceTime(500))
    //   .subscribe((codigo: string) => {
    //     this.modalSeleccionarProducto.searchBySKU(codigo)
    //   })

    this.formHeader.get('listaVendedor').valueChanges.subscribe((rubro: string) => {
      // this.producto_groupArr = null
      this.producto_groupArr = [];
      this.producto_listaMovimientos = null;
      this.producto_listaMovimientosAll = null;
    });
  }
  onRubroSelect(ev) {
    this.optionsFamilia = [];

    const listaRubros = this.formHeader.get('rubros').value;
    if (!listaRubros) return;

    for (let i = 0; i < listaRubros.length; i++) {
      this.loadFamilias(listaRubros[i]);
    }
  }

  private loadFamilias(codigoRubro: Number) {
    this.familiaService.obtenerFamiliaxRubroReporteVenta(this.rutEmpresa, codigoRubro, ({ respuesta }) => {
      const { registros } = respuesta; //.registros.filter(p => p.estado);
      let options = registros.map((p) => ({ value: p.codigo, label: p.nombre }));
      this.optionsFamilia = this.optionsFamilia.concat(options);
    });
  }
  /********* BÚSQUEDA CLIENTE/PRODUCTO*********/
  buscar(pageNumber: number) {
    this.clienteBuscar(pageNumber);
    this.clienteProductoBuscar(pageNumber);
    this.productoBuscar(pageNumber);
  }
  /********* BÚSQUEDA CLIENTE/PRODUCTO *********/

  /********* CLIENTE *********/
  clienteBuscar(pageNumber: number) {

    this.cliente_paginationContext.CurrentPage = pageNumber;

    this.cliente_listaMovimientos = [];
    this.cliente_listaMovimientosAll = [];

    const { fechaDesde, fechaHasta, listaVendedor, listaIptVentas, cliente_con_venta, cliente_sin_venta, listaClientes, listaProductos, incl_cliente_inactivos } = this.formHeader.value;
    const inputParams = {
      entidad: {
        rut_empresa: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        fecha_desde: fechaDesde,
        fecha_hasta: fechaHasta,
        listaVendedor,
        cliente_con_venta,
        cliente_sin_venta,
        listaIptVentas,
        listaClientes,
        listaProductos,
        incl_cliente_inactivos,
      },
      paginaActual: this.cliente_paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1, //this.paginationContext.RecordsByPage
    };
    this.cliente_currentPayload = inputParams;

    this.log('inputParamsCLIENTE', JSON.stringify(inputParams));

    this.cliente_loading = true;
    this.vendedorService.obtenerReporteVentasVendedoresClientes(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        this.cliente_loading = false;
        return;
      }

      const { registros } = respuesta;
      this.cliente_listaMovimientosAll = registros;
      this.cliente_paginationContext.RecordsCount = this.cliente_listaMovimientosAll.length; //totalRegistros
      this.cliente_paginationContext.PagesCount = Math.ceil(this.cliente_paginationContext.RecordsCount / this.cliente_paginationContext.RecordsByPage); //totalPaginas
      this.cliente_paginationContext.CurrentPage = 1;
      let ve = 0;
      this.cliente_listaMovimientosAll.forEach((mov) => {
        mov.rutFormato = this.rutService.AgregarDV(mov.cliente_proveedor_rut);
        if (this.formHeader.get('listaVendedor').value.length > 0) {
          if (ve !== mov.codigo) {
            mov.cantClienteVend = this.cliente_listaMovimientosAll.filter((movimiento) => movimiento.codigo === mov.codigo).length;
          }
          ve = mov.codigo;
        } else {
          mov.cantClienteVend = 0;
        }
      });

      this.showPageCliente(this.cliente_paginationContext.CurrentPage);
      this.calculateTotalesCliente();
      this.cliente_loading = false;
    });
  }

  showPageCliente(pageNumber: number) {
    this.cliente_paginationContext.CurrentPage = pageNumber;
    const start = (this.cliente_paginationContext.CurrentPage - 1) * this.cliente_paginationContext.RecordsByPage;
    this.cliente_listaMovimientos = _.slice(this.cliente_listaMovimientosAll, start, start + this.cliente_paginationContext.RecordsByPage);
  }

  calculateTotalesCliente() {
    // const uniqueClientes = _.uniqBy(this.cliente_listaMovimientosAll, 'cliente_proveedor_rut');
    this.cliente_totales = {
      cantidad_cliente: this.cliente_listaMovimientosAll.length,
      monto_neto_cliente: _.sumBy(this.cliente_listaMovimientosAll, 'monto_neto'),
      descuento_cliente: _.sumBy(this.cliente_listaMovimientosAll, 'descuento'),
      neto_total_cliente: _.sumBy(this.cliente_listaMovimientosAll, 'neto_total'),
    };
  }

  clienteOnPageChange(context: PaginationContext) {
    this.showPageCliente(context.RequestedPage);
  }

  clienteDownloadExcelPdf(type: 'XLS' | 'PDF') {
    const inputParams = _.cloneDeep(this.cliente_currentPayload);
    delete inputParams.cantidadRegistrosPorPagina;
    delete inputParams.paginaActual;

    inputParams.entidad.retornaExcel = type === 'XLS';

    this.log('inputParams', JSON.stringify(inputParams));

    this.vendedorService.obtenerReporteVentasVendedoresClientesExcel(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      if (respuesta) this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo);
    });
  }
  /********* CLIENTE *********/

  /********* CLIENTE_PRODUCTO *********/
  clienteProductoBuscarNotificacion() {

    this.cliente_producto_listaMovimientos = [];
    this.cliente_producto_listaMovimientosAll = [];

    const { fechaDesde, fechaHasta, listaClientes, listaProductos, listaVendedor, rubros, familias, producto_sin_sku, incl_cliente_inactivos } = this.formHeader.value;
    const inputParams = {
      entidad: {
        tipo_notificacion_codigo: 1,
        categoria_modulo_codigo: 4,
        rut_usuario: this.rutUsuario,
        rut_empresa: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        fecha_desde: fechaDesde,
        fecha_hasta: fechaHasta,
        listaClientes: listaClientes !== null ? listaClientes : [],
        listaProductos,
        listaVendedor,
        listaRubro: rubros,
        listaFamilia: familias,
        producto_sin_sku,
        incl_cliente_inactivos,
        environment_functions: ENVIRONMENT_FUNCTIONS
      },
      paginaActual: 1, //this.cliente_producto_paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1, //this.paginationContext.RecordsByPage
    };
    this.cliente_producto_currentPayload = inputParams;
    this.sendMessage(inputParams);
  }

  clienteProductoBuscar(pageNumber: number) {
    this.formValidatorsService.validateAllFormFields(this.formHeader);
    if (!this.formHeader.valid) {
      return;
    }

    this.cliente_producto_paginationContext.CurrentPage = pageNumber;

    this.cliente_producto_listaMovimientos = [];
    this.cliente_producto_listaMovimientosAll = [];

    const { fechaDesde, fechaHasta, listaClientes, listaProductos, listaVendedor, rubros, familias, producto_sin_sku, incl_cliente_inactivos } = this.formHeader.value;
    const inputParams = {
      entidad: {
        rut_empresa: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        fecha_desde: fechaDesde,
        fecha_hasta: fechaHasta,
        listaClientes: listaClientes !== null ? listaClientes : [],
        listaProductos,
        listaVendedor,
        listaRubro: rubros,
        listaFamilia: familias,
        producto_sin_sku,
        incl_cliente_inactivos,
      },
      paginaActual: this.cliente_producto_paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1, //this.paginationContext.RecordsByPage
    };
    this.cliente_producto_currentPayload = inputParams;
    this.log('inputParamsPRODUCTO', JSON.stringify(inputParams));

    this.cliente_producto_loading = true;
    this.vendedorService.obtenerReporteVentasVendedoresClienteProductos(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        this.cliente_producto_loading = false;
        return;
      }

      const { registros } = respuesta;
      this.cliente_producto_listaMovimientosAll = registros;
      this.cliente_producto_paginationContext.RecordsCount = this.cliente_producto_listaMovimientosAll.length; //totalRegistros
      this.cliente_producto_paginationContext.PagesCount = Math.ceil(this.cliente_producto_paginationContext.RecordsCount / this.cliente_producto_paginationContext.RecordsByPage); //totalPaginas
      this.cliente_producto_paginationContext.CurrentPage = 1;

      this.cliente_producto_listaMovimientosAll.forEach((mov) => {
        mov.rutFormato = this.rutService.AgregarDV(mov.cliente_proveedor_rut);
      });

      this.showPageClienteProducto(this.cliente_producto_paginationContext.CurrentPage);
      this.calculateTotalesClienteProducto();
      this.cliente_producto_loading = false;
    });
  }

  sendMessage(inputParams: any) {
    this.signalRMessageService.send(inputParams).subscribe(
      () => {
        //console.log('Mensaje enviado con éxito');
      },
      (error) => {
        console.error('Error al enviar el mensaje:', error);
      }
    );
  }

  showPageClienteProducto(pageNumber: number) {
    this.cliente_producto_paginationContext.CurrentPage = pageNumber;
    const start = (this.cliente_producto_paginationContext.CurrentPage - 1) * this.cliente_producto_paginationContext.RecordsByPage;
    this.cliente_producto_listaMovimientos = _.slice(this.cliente_producto_listaMovimientosAll, start, start + this.cliente_producto_paginationContext.RecordsByPage);
  }

  calculateTotalesClienteProducto() {
    this.cliente_producto_totales = {
      cantidad_producto: this.cliente_producto_listaMovimientosAll.length,
      monto_neto_producto: _.sumBy(this.cliente_producto_listaMovimientosAll, 'monto_neto'),
      descuento_producto: _.sumBy(this.cliente_producto_listaMovimientosAll, 'descuento'),
      neto_total_producto: _.sumBy(this.cliente_producto_listaMovimientosAll, 'neto_total'),
    };
  }

  clienteProductoOnPageChange(context: PaginationContext) {
    this.showPageClienteProducto(context.RequestedPage);
  }

  clienteProductoDownloadExcelPdf(type: 'XLS' | 'PDF') {
    const inputParams = _.cloneDeep(this.cliente_producto_currentPayload);
    delete inputParams.cantidadRegistrosPorPagina;
    delete inputParams.paginaActual;

    inputParams.entidad.retornaExcel = type === 'XLS';

    this.log('inputParams', JSON.stringify(inputParams));


    this.vendedorService.obtenerReporteVentasVendedoresClienteProductosExcel(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      if (respuesta) this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo);
    });
  }
  /********* END CLIENTE_PRODUCTO *********/

  /********* PRODUCTO *********/

  productoBuscarNotificacion() {

    this.producto_listaMovimientos = [];
    this.producto_listaMovimientosAll = [];

    const { fechaDesde, fechaHasta, listaClientes, listaProductos, listaVendedor, rubros, familias, producto_sin_sku, incl_cliente_inactivos } = this.formHeader.value;
    const inputParams = {
      entidad: {
        tipo_notificacion_codigo: 2,
        categoria_modulo_codigo: 4,
        rut_usuario: this.rutUsuario,
        rut_empresa: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        fecha_desde: fechaDesde,
        fecha_hasta: fechaHasta,
        listaClientes: listaClientes !== null ? listaClientes : [],
        listaProductos,
        listaVendedor,
        listaRubro: rubros,
        listaFamilia: familias,
        producto_sin_sku,
        environment_functions: ENVIRONMENT_FUNCTIONS
      },
      paginaActual: 1, //this.cliente_producto_paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1, //this.paginationContext.RecordsByPage
    };
    this.cliente_producto_currentPayload = inputParams;
    this.sendMessage(inputParams);
  }

  productoBuscar(pageNumber: number) {
    this.formValidatorsService.validateAllFormFields(this.formHeader);
    if (!this.formHeader.valid) {
      return;
    }

    this.producto_paginationContext.CurrentPage = pageNumber;

    this.producto_listaMovimientos = [];
    this.producto_listaMovimientosAll = [];

    const { fechaDesde, fechaHasta, listaClientes, listaProductos, listaVendedor, rubros, familias, producto_sin_sku } = this.formHeader.value;
    const inputParams = {
      entidad: {
        rut_empresa: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        fecha_desde: fechaDesde,
        fecha_hasta: fechaHasta,
        listaClientes: listaClientes !== null ? listaClientes : [],
        listaProductos,
        listaVendedor,
        listaRubro: rubros,
        listaFamilia: familias,
        producto_sin_sku,
      },
      paginaActual: this.producto_paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1, //this.paginationContext.RecordsByPage
    };
    this.producto_currentPayload = inputParams;

    this.log('inputParamsPRODUCTO', JSON.stringify(inputParams));

    this.producto_loading = true;
    this.vendedorService.obtenerReporteVentasVendedoresProductos(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        this.producto_loading = false;
        return;
      }

      const { registros } = respuesta;
      this.producto_listaMovimientosAll = registros;
      if (listaVendedor.length > 0) {
        this.producto_groupArr = registros.reduce((r, { codigo }) => {
          if (!r.some((o) => o.codigo == codigo)) {
            r.push({
              codigo,
              vendedor_nombre: registros.find((x) => x.codigo == codigo).nombre,
              producto_groupItem: registros.filter((v) => v.codigo == codigo),
            });
          }
          return r;
        }, []);
      } else {
        this.producto_groupArr = registros.reduce((r, { familia_codigo }) => {
          if (!r.some((o) => o.familia_codigo == familia_codigo)) {
            r.push({
              familia_codigo,
              familia_nombre: registros.find((x) => x.familia_codigo == familia_codigo).familia_nombre,
              producto_groupItem: registros.filter((v) => v.familia_codigo == familia_codigo),
            });
          }
          return r;
        }, []);
      }

      this.producto_paginationContext.RecordsCount = this.producto_groupArr.length; //totalRegistros
      this.producto_paginationContext.PagesCount = Math.ceil(this.producto_paginationContext.RecordsCount / this.producto_paginationContext.RecordsByPage); //totalPaginas
      //this.producto_paginationContext.CurrentPage = 1

      // this.producto_listaMovimientosAll.forEach(mov => {
      //   mov.rutFormato = this.rutService.AgregarDV(mov.cliente_proveedor_rut)
      // })

      this.showPageProducto(this.producto_paginationContext.CurrentPage);
      this.calculateTotalesProducto();
      this.producto_loading = false;
    });
  }

  showPageProducto(pageNumber: number) {
    this.producto_paginationContext.CurrentPage = pageNumber;
    const start = (this.producto_paginationContext.CurrentPage - 1) * this.producto_paginationContext.RecordsByPage;
    this.producto_listaMovimientos = _.slice(this.producto_groupArr, start, start + this.producto_paginationContext.RecordsByPage);
  }

  calculateTotalesProducto() {
    this.producto_totales = {
      cantidad_producto: _.sumBy(this.producto_listaMovimientosAll, 'cantidad'),
      monto_neto_producto: _.sumBy(this.producto_listaMovimientosAll, 'monto_neto'),
      descuento_producto: _.sumBy(this.producto_listaMovimientosAll, 'descuento'),
      neto_total_producto: _.sumBy(this.producto_listaMovimientosAll, 'neto_total'),
    };
  }

  productoOnPageChange(context: PaginationContext) {
    this.showPageProducto(context.RequestedPage);
  }

  productoDownloadExcelPdf(type: 'XLS' | 'PDF') {
    const inputParams = _.cloneDeep(this.producto_currentPayload);
    delete inputParams.cantidadRegistrosPorPagina;
    delete inputParams.paginaActual;

    inputParams.entidad.retornaExcel = type === 'XLS';

    this.log('inputParams', JSON.stringify(inputParams));

    this.vendedorService.obtenerReporteVentasVendedoresProductosExcel(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      if (respuesta) this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo);
    });
  }
  /********* PRODUCTO *********/

  abrirModalSeleccion() {
    this.abrirModalSeleccionarCliente();
  }

  abrirModalSeleccionarCliente() {
    this.modalSeleccionarCliente.show({ paginateLocally: true });
  }
  abrirModalSeleccionarClienteSeleccionados() {
    this.modalSeleccionarCliente.showSelected({
      paginateLocally: true,
      allowUncheckSelected: true,
    });
  }
  onClienteSeleccionadoMultiple({ data, origen }) {
    this.limpiarDataSeleccionada();
    // this.clienteSeleccionado = data
    this.clientesSeleccionados = data;
    //this.clientesSeleccionadosFormatted = _.uniq(this.clientesSeleccionados.map(p => p.rut)).join(', ')
    this.clientesSeleccionadosFormatted = this.clientesSeleccionados.map((p) => p.rut);
    this.formHeader.get('listaClientes').setValue(this.clientesSeleccionadosFormatted);
  }

  limpiarDataSeleccionada() {
    // this.clienteSeleccionado = null
    this.clientesSeleccionados = null;
  }

  verClientesSeleccionados() {
    this.modalShowClientes.show(this.clientesSeleccionados);
  }

  abrirModalSeleccionarProducto() {
    this.modalSeleccionarProducto.MostrarConConfiracionVendedorCliente({
      cleanData: true,
      showUnidadDeNegocioIfAllowed: false,
      defaultUnidadNegocio: 0,
      origen: this.RB_VC,
    });
  }

  abrirModalSeleccionarProductosSeleccionados() {
    this.modalSeleccionarProducto.showSelected(this.productosMultiplesSeleccionados);
  }

  onProductoSeleccionado({ data: _productoSeleccionado, origen }) {
    this.productosMultiplesSeleccionados = [];
    this.productosMultiplesSeleccionados.push(_productoSeleccionado);
    this.formHeader.get('listaProductos').setValue(this.productosMultiplesSeleccionados.map((p) => p.codigo));
    this.setCodigoProductoValidators('ADD');
  }

  onProductoNoEncontrado() {
    this.setCodigoProductoValidators('ADD');
    this.productosMultiplesSeleccionados = null;
    this.formHeader.get('listaProductos').setValue([]);
  }

  onMultiplesProductosSeleccionados(data: IProductMultipleSelection) {
    this.log(data);
    this.productosMultiplesSeleccionados = data.data;
    if (data.data.length !== 1) {
      this.formHeader.get('listaProductos').setValue(this.productosMultiplesSeleccionados.map((p) => p.codigo));
      this.setCodigoProductoValidators('ADD');
    } else {
      this.formHeader.get('listaProductos').setValue(this.productosMultiplesSeleccionados.map((p) => p.codigo));
      this.setCodigoProductoValidators('REMOVE');
    }
  }
  setCodigoProductoValidators(type: 'ADD' | 'REMOVE') {
    if (type === 'ADD') {
      this.formHeader.get('listaProductos').setValidators([Validators.required, Validators.min(1)]);
    } else {
      this.formHeader.get('listaProductos').setValidators([]);
    }
    this.formHeader.get('listaProductos').updateValueAndValidity();
  }

  uncheckProducto(producto) {
    this.productosMultiplesSeleccionados = this.productosMultiplesSeleccionados.filter((p) => p.sku !== producto.sku);
    if (this.productosMultiplesSeleccionados.length === 0) this.productosMultiplesSeleccionados = null;
  }

  LimpiarData() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth();

    this.formHeader.reset();
    this.formHeader.get('fechaDesde').setValue(initDate);
    this.formHeader.get('fechaHasta').setValue(currentDate);
    this.formHeader.get('tipoVista').setValue(this.RB_TIPO_VISTA_CLIENTE);
    this.formHeader.get('listaVendedor').setValue([]);
    this.formHeader.get('listaClientes').setValue([]);
    this.formHeader.get('listaIptVentas').setValue([]);
    this.formHeader.get('cliente_con_venta').setValue(true);
    this.formHeader.get('cliente_sin_venta').setValue(false);
    this.formHeader.get('producto_sin_sku').setValue(true);
    this.formHeader.get('incl_cliente_inactivos').setValue(false);
    this.formHeader.get('listaProductos').setValue([]);
    this.formHeader.get('rubros').setValue([]);
    this.formHeader.get('familias').setValue([]);
    this.clientesSeleccionados = null;
    this.productosMultiplesSeleccionados = null;

    this.cliente_listaMovimientos = null;
    this.cliente_listaMovimientosAll = null;
    this.cliente_producto_listaMovimientos = null;
    this.cliente_producto_listaMovimientosAll = null;
    this.producto_listaMovimientos = null;
    this.producto_listaMovimientosAll = null;
    this.producto_groupArr = null;
    this.modalSeleccionarProducto.limpiar();
  }

  closeAlert() {
    //this.alert.nativeElement.classList.remove('show');
  }
}


